import { render, staticRenderFns } from "./EstateSellContactsSection.vue?vue&type=template&id=5253c90c"
import script from "./EstateSellContactsSection.vue?vue&type=script&lang=js"
export * from "./EstateSellContactsSection.vue?vue&type=script&lang=js"
import style0 from "./EstateSellContactsSection.vue?vue&type=style&index=0&id=5253c90c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports